var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendingDecrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6633 15L15.5716 13.0917L11.505 9.025L8.17164 12.3583L1.99664 6.175L3.17164 5L8.17164 10L11.505 6.66667L16.755 11.9083L18.6633 10V15H13.6633Z",
    fill: "#E00000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingDecrease);
export default __webpack_public_path__ + "static/media/trending-decrease.9f59379a.svg";
export { ForwardRef as ReactComponent };